<template>
  <div class="deviceAnalysis section" v-loading="isLoading" element-loading-spinner="el-icon-loading">
    <div class="section-header">
      <div></div>
    <div class="section-selector">
      <el-select v-model="selectedOption">
        <el-option
          v-for="item in options"
          :key="item.nameEn"
          :label="item.label" 
          style="text-align:center;"
          :value="item.nameEn"
        >
          {{item.label}}
        </el-option>
      </el-select>
    </div>
    <div class="tool">
        <el-date-picker
          v-model="selectedDate"
          :editable="false"
          :clearable="false"
        >
        </el-date-picker>
      </div>
    </div>
    <div class="section-chart">
      <echart-line
        :category="chartData.category"
        :data="chartData.data"
        :area="chartData.isArea"
        :unit="chartData.unit"
         unitX="H"
      ></echart-line>
    </div>
  </div>
</template>
<script>
import echartLine from "@/components/echarts/line";
import { mapGetters,mapState } from 'vuex';
export default {
  components: {
    echartLine
  },
  props: {
    devData: {
      type: Object
    }
  },
  data() {
    return {
      selectedDate: new Date(), // 所选时间
      options: {}, // 可选参数列表
      selectedOption: null, // 所选参数
      chartData: {
        category: [], // 数据模块
        data: [],
        unit: null,
        isArea: true
      }, // 图表数据
      isLoading: false // 正在加载数据
    }
  },
  computed: {
    ...mapGetters({
      deviceInfo: 'getDeviceInfo'
    }),
    ...mapState({
      method: state => state.user.method,
      isMicroService: state => state.user.isMicroService,
      code: state => state.user.code,
      resData: state => state.user.resData
    })
  },
  watch: {
    deviceInfo: {
      handler() {
        this.queryData()
      },
      deep: true
    },
    selectedOption () {
      this.queryData()
    },
    selectedDate () {
      this.queryData()
    }
  },
  methods: {
    queryFields () {
      let param = {
        devcode: this.deviceInfo.devcode,
        pn: this.deviceInfo.pn,
        sn: this.deviceInfo.sn,
        devaddr: this.deviceInfo.devaddr,
        lang: this.$lang.currentLang
      }
       let url = this.isMicroService ? "/ppe/api/auth/web/queryDeviceChartField" : "queryDeviceChartField";
      return  this.$request[this.method](url, param).then(res => {
        if (!res[this.code]) {
          let options = {}
          res[this.resData].forEach(item => {
            options[item.e0] = {
              nameEn: item.e0,
              nameCh: item.e1,
              unit: item.e3,
              // label: this.$lang.currentLang == 'en_US' ? item.e0 : item.e1
              label:item.e1,
            }
          })
          this.options = options
          this.selectedOption =  res[this.resData][0].e0
        }
      })
    },
    queryData () {
      let date = this.$filter.formatDate(this.selectedDate,'yyyy-MM-dd'),
        option = this.options[this.selectedOption]
      let param = {
        pn: this.deviceInfo.pn,
        devcode: this.deviceInfo.devcode,
        sn: this.deviceInfo.sn,
        devaddr: this.deviceInfo.devaddr,
        field: option.nameEn,
        precision: 5,
        sdate: date + ' 00:00:00',
        edate: date + ' 23:59:59',
        i18n: this.$lang.currentLang
      }
      this.isLoading = true
      this.$request.get('queryDeviceChartFieldDetailData', param).then(res => {
        let chartData = {
          category: [],
          data: [{
            name: option.label,
            value: []
          }],
          unit: option.unit,
          isArea: option.unit === 'kW' || option.unit === 'W'
        }

        if (!res.err) {
          res.dat.forEach(item => {
            chartData.category.push(item.key)
            chartData.data[0].value.push((item.val - 0).toFixed(2))
          })
        } else {
          chartData.category.push(this.$filter.formatDate(this.selectedDate, 'yyyy-MM-dd') + ' 00:00:00', this.$filter.formatDate(this.selectedDate, 'yyyy-MM-dd') + ' 23:59:59')
          chartData.data[0].value.push('0.00', '0.00')
        }

        this.chartData = chartData
        this.isLoading = false
      })
    }
  },
  created() {
    this.queryFields()
  },
}
</script>
<style lang="less">
.deviceAnalysis {
  .section-selector {
    .el-select {
      min-width: 25%;
      .el-input__inner {
        border-radius: 20px;
        padding: 14px;
        text-align: center;
      }
    }
  }
}
</style>

<style lang="less" scoped>
@import url('../../../../assets/css/mixin.less');
.deviceAnalysis {
  display: flex;
  flex-direction: column;
  .section-header {
    margin-top:20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .section-selector {
    display: flex;
    justify-content: center;
  }
  .section-chart {
    flex: 1;
    padding: 0 10px;
  }
}
 .section{
      border:none;
      box-shadow:none;
      padding:0;
  }
</style>